import { TFunction } from 'i18next';
import { matchPath } from 'react-router';
import { Path } from '~/router';

/**
 * This function matches the current path to all possible page paths and returns the fitting title.
 * @returns
 */
export const getPageTitle = ({
  path,
  t,
  search,
  dealershipName
}: {
  path: string;
  t: TFunction;
  search: string;
  dealershipName: string;
}) => {
  const pageTitles: Record<Path, string> = {
    '/': t('TDC'),
    '/credit-application/:dealershipSlug': t('Credit Application'),
    '/dashboard': t('TDC'),
    '/dashboard/:dealershipSlug/:transactionId': dealershipName,
    '/dashboard/:dealershipSlug/:transactionId/additional-documents':
      t('Documents'),
    '/dashboard/:dealershipSlug/:transactionId/additional-documents/upload':
      t('Documents'),
    '/dashboard/:dealershipSlug/:transactionId/additional-documents/upload/:documentType':
      t('Documents'),
    '/dashboard/:dealershipSlug/:transactionId/additional-documents/upload/:documentType/capture':
      t('Documents'),
    '/dashboard/:dealershipSlug/:transactionId/coBuyer': t('Co-Buyer'),
    '/dashboard/:dealershipSlug/:transactionId/credit-application/acknowledgements':
      search.includes('modification=true')
        ? t('Credit Application Modification')
        : t('Credit Application'),
    '/dashboard/:dealershipSlug/:transactionId/credit-application/address':
      search.includes('modification=true')
        ? t('Credit Application Modification')
        : t('Credit Application'),
    '/dashboard/:dealershipSlug/:transactionId/credit-application/employment':
      search.includes('modification=true')
        ? t('Credit Application Modification')
        : t('Credit Application'),
    '/dashboard/:dealershipSlug/:transactionId/glove-compartment':
      t('View Documents'),
    '/dashboard/:dealershipSlug/:transactionId/glove-compartment/:formSubmissionId':
      t('View Documents'),
    '/dashboard/:dealershipSlug/:transactionId/glove-compartment/document/:documentId':
      t('View Documents'),
    '/dashboard/:dealershipSlug/:transactionId/personalInformation': t(
      'Personal Information'
    ),
    '/dashboard/:dealershipSlug/:transactionId/prequal': t('Prequal'),
    '/dashboard/:dealershipSlug/:transactionId/purchase-vehicle':
      t('Purchase Vehicle'),
    '/dashboard/:dealershipSlug/:transactionId/sign/next':
      t('Documents to Sign'),
    '/dashboard/:dealershipSlug/:transactionId/trade-vehicle/information':
      t('Trade Vehicle'),
    '/dashboard/:dealershipSlug/:transactionId/trade-vehicle/payoff':
      t('Trade Vehicle'),
    '/dashboard/:dealershipSlug/:transactionId/trade-vehicle/pictures':
      t('Trade Vehicle'),
    '/dashboard/:dealershipSlug/:transactionId/trade-vehicle/registrationCard':
      t('Trade Vehicle'),
    '/onboarding': t('Onboarding'),
    '/onboarding/:dealershipSlug/:transactionId/step1': t('Onboarding'),
    '/onboarding/:dealershipSlug/:transactionId/step2': t('Onboarding'),
    '/prequal/:dealershipSlug': t('Prequal'),
    '/scanner/:transactionId': t('Scan Documents'),
    '/scanner/:transactionId/:temporaryToken': t('Scan Documents'),
    '/scanner/:transactionId/:temporaryToken/kiosk': t('Scan Documents'),
    '/scanner/done': t('Scan Documents'),
    '/signin': t('Sign In'),
    '/signup': t('Sign Up'),
    '/user/security': t('Security')
  };

  for (const [routePattern, title] of Object.entries(pageTitles)) {
    const match = matchPath(
      {
        path: routePattern,
        end: true // This ensure that the entire URL path name is matched
      },
      path
    );

    if (match) {
      return title;
    }
  }

  return 'TDC';
};
